export default "__VITE_ASSET__e46bef57__"